import React from 'react';
import CookieConsent from 'react-cookie-consent';
import { useTranslation } from 'react-i18next'

const CustomCookieConsent = () => {
    const { t } = useTranslation()

    return (
        <CookieConsent
            location="bottom"
            buttonText={t('cookie-consent-accept')}
            declineButtonText="Decline"
            cookieName="gatsby-gdpr-google-analytics"
            style={{ background: "#2B373B", color: "#fff", alignItems: "center" }}
            buttonStyle={{
                background: "#21ACFF",
                color: "#fff",
                fontSize: "14px",
                borderRadius: "5px",
            }}
            declineButtonStyle={{
                background: "#ccc",
                color: "#000",
                fontSize: "14px",
                borderRadius: "5px",
            }}
            expires={150}
            onAccept={() => {
                console.log("Cookies accepted!");
            }}
            onDecline={() => {
                console.log("Cookies declined!");
            }}
        >
            { t('cookie-consent') }
            {/*<a href="/privacy-policy" style={{ color: "#ffd700" }}>*/}
            {/*    Learn more*/}
            {/*</a>*/}
        </CookieConsent>
    );
};

export default CustomCookieConsent;
